import {railsAppRootUrls} from '@/constants/app.js'
import {useEnv} from '@/composables/use-env.js'
import {computed} from 'vue'

//Get environment
const {isTest, isLocal, isDev, isQa, isStaging, isProduction} = useEnv()

//Rails app root URL
const railsAppRootUrl = computed(() => {
  if (isTest.value) {
    return railsAppRootUrls.TEST
  }
  if (isLocal.value) {
    return railsAppRootUrls.LOCAL
  }
  if (isDev.value) {
    return railsAppRootUrls.DEV
  }
  if (isQa.value) {
    return railsAppRootUrls.QA
  }
  if (isStaging.value) {
    return railsAppRootUrls.STAGING
  }
  if (isProduction.value) {
    return railsAppRootUrls.PRODUCTION
  }
  throw new Error('Unknown environment')
})

//Rails API base URL
const railsApiBaseUrl = computed(() => {
  return `${railsAppRootUrl.value}/api/v1`
})

/**
 * Rails URLs composable
 */
export function useRailsUrls() {
  return {
    railsAppRootUrl,
    railsApiBaseUrl,
  }
}
